/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CommitPlayerExposureChangesInput = {|
  exposures: $ReadOnlyArray<?ExposureInput>,
  clientMutationId?: ?string,
|};
export type ExposureInput = {|
  gmPlayerId: string,
  exposure: number,
|};
export type CommitPlayerExposureChangesMutationVariables = {|
  input: CommitPlayerExposureChangesInput
|};
export type CommitPlayerExposureChangesMutationResponse = {|
  +commitPlayerExposureChanges: ?{|
    +success: ?boolean
  |}
|};
export type CommitPlayerExposureChangesMutation = {|
  variables: CommitPlayerExposureChangesMutationVariables,
  response: CommitPlayerExposureChangesMutationResponse,
|};
*/


/*
mutation CommitPlayerExposureChangesMutation(
  $input: CommitPlayerExposureChangesInput!
) {
  commitPlayerExposureChanges(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CommitPlayerExposureChangesPayload",
    "kind": "LinkedField",
    "name": "commitPlayerExposureChanges",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CommitPlayerExposureChangesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommitPlayerExposureChangesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "704b64605c8fa72b8c746728b920ac3d",
    "id": null,
    "metadata": {},
    "name": "CommitPlayerExposureChangesMutation",
    "operationKind": "mutation",
    "text": "mutation CommitPlayerExposureChangesMutation(\n  $input: CommitPlayerExposureChangesInput!\n) {\n  commitPlayerExposureChanges(input: $input) {\n    success\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'bf2b2e62ce65e5108b35c1c009d38e6b';

module.exports = node;
